import { useState } from "react";
import { Chip, MenuItem, Select, Box, InputLabel, IconButton } from "@mui/material";
import FilterInput from "./FilterInput";
import { FormattedMessage, useIntl } from "react-intl";
import CloseIcon from '@mui/icons-material/Close';

const DEBUG = false;

export default function FilterChip({ filterKey, availableFilters, value, setValue, removeFilter }) {
    const [editing, setEditing] = useState(!filterKey); // Start in edit mode if no filter is selected yet

    //const filterConfig = filterKey ?
    //    availableFilters[filterKey] : null;

    const filterConfig = availableFilters.find((filterConfig) => filterConfig.name === filterKey);

    if (DEBUG) console.log("FilterChip :: render");
    if (DEBUG) console.log(filterKey, availableFilters, value, setValue, removeFilter);

    return (<Box
        sx={{
            display: 'inline-flex',
            alignItems: 'center',
            borderRadius: '16px',
            //padding: '8px 12px',
            padding: '0px 5px',
            //border: '1px solid #ccc',
            backgroundColor: '#f5f5f5',
            cursor: 'pointer',
            marginTop: 0.5,
            minHeight: '3.7em',
            '&:hover': {
                backgroundColor: '#e0e0e0',
            },
        }}
    >
        <Box
            px={1}
            display="flex"
            alignItems="center"
            gap={1}>
            {/* Filter Type Dropdown */}
            <Select
                variant="standard"
                disableUnderline="true"
                InputProps={{
                    disableUnderline: true, // MUI built-in prop to remove underline
                }}
                value={filterKey || "none"}
                onChange={
                    (e) => {
                        setValue(
                            e.target.value, "");
                    }
                }
                onClose={(e) => {
                    if (DEBUG) console.log("onClose", e);
                    if (e.currentTarget) {
                        e.currentTarget.blur(); // Ensure focus is removed after selection
                    }
                    if (e.target) {
                        e.target.blur();
                    }
                }}
                size="small"
                onOpen={
                    null
                    //() => setEditing(true)
                }
                sx={{ minWidth: 120 }}
            >
                <MenuItem value="none">
                    <em>
                        <FormattedMessage
                            id="filter.placeholder" />
                    </em>
                </MenuItem>
                {availableFilters.map((filter) => (
                    <MenuItem key={filter.name} value={filter.name}>
                        <FormattedMessage
                            id={`filterType.${filter.name}`} />
                    </MenuItem>
                ))}
            </Select>

            {/* Filter Value Input */}
            {filterConfig && editing ? (
                <FilterInput
                    type={filterConfig.type}
                    value={value}
                    onChange={(newValue) => {
                        setValue(filterKey, newValue);
                        //setEditing(false);
                    }}
                    items={filterConfig.options}
                    scale={filterConfig.scale}
                />
            ) : (
                <span
                    onClick={
                        null
                        //() => setEditing(true)
                    }>
                    {value || ""}
                </span>
            )}
        </Box>
        <IconButton
            size="small"
            sx={{
                width: 24,
                height: 24,
                padding: 0,
                borderRadius: '50%',
                backgroundColor: '#ccc',
                '&:hover': {
                    backgroundColor: '#aaa',
                },
                marginLeft: 1, // optional spacing from the rest of the content
            }}
            onClick={removeFilter} // your deletion handler
        >
            <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
    </Box>);
}